var _circle, _path, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcoEmoji = function SvgIcoEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.363 12.378c.305.264.714.46 1.165.59a5.37 5.37 0 0 0 1.472.199 5.37 5.37 0 0 0 1.472-.199c.451-.13.86-.326 1.165-.59",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.667,
    r: 0.917,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.667,
    r: 0.917,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
};
export default SvgIcoEmoji;